'use client';

import { FadeUpSection, staggerDelay } from '@/components/fade-up-section';
import PageShell from '@/components/page-shell';
import { useContent } from '@/hooks/use-content';

export default function TermsPage() {
  const c = useContent();
  const p = c.termsPage;

  return (
    <PageShell>
      <main className="max-w-4xl mx-auto px-8 md:px-16 py-12 md:py-16 text-start">
        <FadeUpSection as="div">
          <h1 className="text-3xl md:text-5xl font-black mb-8">{p.title}</h1>
        </FadeUpSection>
        {p.body.split(/\n\n+/).map((paragraph, idx) => (
          <FadeUpSection key={idx} as="div" delay={staggerDelay(idx)} className="text-lg leading-relaxed mb-6 text-[#1a1c1c]">
            {paragraph}
          </FadeUpSection>
        ))}
      </main>
    </PageShell>
  );
}
